import { Box, Button, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import axios from "axios";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import AdminNavbar from "../components/nav-bar";
import DownloadIcon from '@mui/icons-material/Download';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ReviewingArticles from "../components/reviewing-articles";
import ApprovedArticles from "../components/approved-articles";

function Articles() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const status = queryParams.get("status");
    
    return (
        <Box>
            <AdminNavbar/>

            <Box sx={{ padding: 2 }}>
              {status === '0' && <ReviewingArticles status={status}/>}
              {status === '1' && <ApprovedArticles status={status}/>}

            </Box>
        </Box>
    );
}

export default Articles;
